import deleteEventUserApi from './deleteEventUserApi';
import getAdminTokenApi from './getAdminTokenApi';
import getAttributesListApi from './getAttributesListApi';
import getConfigListApi from './getConfigListApi';
import getEventUsersApi from './getEventUsersApi';
import getHallTokenByEventId from './getHallTokenByEventId';
import getInitialConfigList from './getInitialConfigList';
import saveConfigApi from './saveConfigApi';
import setEventUserApi from './setEventUserApi';
import updateEventUserApi from './updateEventUserApi';

export default {
  deleteEventUserApi,
  getAdminTokenApi,
  getAttributesListApi,
  getConfigListApi,
  getEventUsersApi,
  getHallTokenByEventId,
  getInitialConfigList,
  saveConfigApi,
  setEventUserApi,
  updateEventUserApi,
};
